function debounce(func, timeout = 300){
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => { func.apply(this, args); }, timeout);
    };
  }
  function onKeyUpEscape(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;
  
    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;
  
    const summaryElement = openDetailsElement.querySelector('summary');
    openDetailsElement.removeAttribute('open');
    summaryElement.setAttribute('aria-expanded', false);
    summaryElement.focus();
  }

$(document).ready(function(){
    var innerSliderLook = document.querySelectorAll(".innersliderLook");

    for (var i = 0, len = innerSliderLook.length; i < len; i++) {
      var innerSliderSingleLook = innerSliderLook[i];
      var innerflickityLook = new Flickity(innerSliderSingleLook, {
        contain: true,
        prevNextButtons: true,
        pageDots: false,
        groupCells: true,
        draggable: false,
        resize: true,
        groupCells: 1,
        accessibility: false,
        imagesLoaded: true,
        autoPlay: false,
        on: {
          settle: function () {

          },
          ready: function () {
            setTimeout(() => { this.resize(); }, 3000);

          }
        }

      });

    }

    const mainTicker = new Flickity('.usp-carousel', {
      accessibility: true,
      resize: true,
      wrapAround: true,
      prevNextButtons: false,
      pageDots: false,
      percentPosition: true,
      setGallerySize: true,
      pageDots: false,
      initialIndex: 0,
      fullscreen: true, 
      cellAlign: "center"
    });

    // Set initial position to be 0
    mainTicker.x = 0;

    // Start the marquee animation
    play();

    // Main function that 'plays' the marquee.
    function play() {
      // Set the decrement of position x
      mainTicker.x -= 1.5;

      // Settle position into the slider
      mainTicker.settle(mainTicker.x);

      // Set the requestId to the local variable
      requestId = window.requestAnimationFrame(play);
    }

    // Main function to cancel the animation.
    function pause() {
      if(requestId) {
        // Cancel the animation
        window.cancelAnimationFrame(requestId)

        // Reset the requestId for the next animation.
        requestId = undefined;
      }
    }

    // Pause on hover/focus
    $('.usp-carousel').on('mouseenter focusin', e => {
      pause();
    })

    // Unpause on mouse out / defocus
    $('.usp-carousel').on('mouseleave', e => {
      play();
    })

    var langArray = [];
    $('.vodiapicker option').each(function(){
      var img = $(this).attr("data-thumbnail");
      var text = this.innerText;
      var value = $(this).val();
      var item = '<li><img src="'+ img +'" alt="" value="'+value+'"/><span>'+ text +'</span></li>';
      langArray.push(item);
    })

    $('.a').html(langArray);

    //Set the button value to the first el of the array
    $('.btn-select').html(langArray[0]);
    var val = $('.vodiapicker option').val();
    $('.btn-select').attr('value', val);

    //change button stuff on click
    $('.a li').click(function(){
      var img = $(this).find('img').attr("src");
      var value = $(this).find('img').attr('value');
      var text = this.innerText;
      var item = '<li><img src="'+ img +'" alt="" /><span>'+ text +'</span></li>';
      $('.btn-select').html(item);
      $('.btn-select').attr('value', value);
      $(".b").toggle();
      setTimeout(function(){
        window.location.href = value;
      }, 1000);

    });

    $(".btn-select").click(function(){
      $(".b").toggle();
    });

    //check local storage for the lang
    var sessionLang = localStorage.getItem('lang');
    if (sessionLang){
      //find an item with value of sessionLang
      var langIndex = langArray.indexOf(sessionLang);
      $('.btn-select').html(langArray[langIndex]);
      $('.btn-select').attr('value', sessionLang);
    } else {
      var langIndex = langArray.indexOf('ch');
      $('.btn-select').html(langArray[langIndex]);
      //$('.btn-select').attr('value', 'en');
    }
  });